// Mace product cards: image arrows (snippets/mba-card-gallery.liquid) + quick add (snippets/mba-card-quick-add.liquid)
(() => {
  if (window.mbaCardInit) return;
  window.mbaCardInit = true;

  window.mbaAddToCart = async (variantId) => {
    const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    const body = { id: Number(variantId), quantity: 1 };
    if (cart && typeof cart.getSectionsToRender === 'function') {
      body.sections = cart.getSectionsToRender().map((section) => section.id);
      body.sections_url = window.location.pathname;
    }
    const response = await fetch(`${window.routes ? window.routes.cart_add_url : '/cart/add'}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });
    const state = await response.json();
    if (!response.ok || state.status) throw new Error(state.description || state.message || 'Fejl');
    if (cart && typeof cart.renderContents === 'function') {
      if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
      cart.renderContents(state);
    }
    return state;
  };

  const showImage = (gallery, index) => {
    const srcs = gallery.dataset.srcs.split('|');
    const count = Math.min(srcs.length, gallery.querySelectorAll('.mba-cg__bar span').length || srcs.length);
    const next = (index + count) % count;
    const img = gallery.closest('.card__media')?.querySelector('.media img');
    if (!img) return;
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.src = srcs[next];
    gallery.dataset.index = next;
    gallery.querySelectorAll('.mba-cg__bar span').forEach((bar, i) => bar.classList.toggle('is-active', i === next));
  };

  document.addEventListener('click', async (event) => {
    const step = event.target.closest('[data-cg-step]');
    if (step) {
      event.preventDefault();
      event.stopPropagation();
      const gallery = step.closest('.mba-cg');
      showImage(gallery, Number(gallery.dataset.index || 0) + Number(step.dataset.cgStep));
      return;
    }

    const open = event.target.closest('[data-qa-open]');
    if (open) {
      event.preventDefault();
      const wrapper = open.closest('.mba-qa');
      const isOpen = wrapper.classList.toggle('is-open');
      open.setAttribute('aria-expanded', isOpen);
      return;
    }

    const add = event.target.closest('[data-qa-add]');
    if (add) {
      event.preventDefault();
      const wrapper = add.closest('.mba-qa');
      add.disabled = true;
      wrapper.classList.add('is-loading');
      try {
        await window.mbaAddToCart(add.dataset.qaAdd);
        wrapper.classList.remove('is-open');
      } catch (error) {
        const label = wrapper.querySelector('.mba-qa__label');
        if (label) label.textContent = error.message;
      } finally {
        add.disabled = false;
        wrapper.classList.remove('is-loading');
      }
      return;
    }

    // Click outside closes open quick-add panels
    document.querySelectorAll('.mba-qa.is-open').forEach((qa) => {
      if (!qa.contains(event.target)) qa.classList.remove('is-open');
    });
  });

  // Swipe on touch devices
  let touchX = null;
  document.addEventListener('touchstart', (e) => {
    if (e.target.closest('.card__media')) touchX = e.touches[0].clientX;
  }, { passive: true });
  document.addEventListener('touchend', (e) => {
    if (touchX === null) return;
    const media = e.target.closest('.card__media');
    const gallery = media && media.querySelector('.mba-cg');
    const dx = e.changedTouches[0].clientX - touchX;
    touchX = null;
    if (gallery && Math.abs(dx) > 40) showImage(gallery, Number(gallery.dataset.index || 0) + (dx < 0 ? 1 : -1));
  }, { passive: true });
})();

// Per-collection Bestseller tag: the 4 best-selling products of the current collection get the
// same tag as the store-wide top 12 (fetched from sections/mba-bs-handles.liquid).
(() => {
  const path = window.location.pathname;
  const match = path.match(/^\/collections\/([^/]+)\/?$/);
  if (!match || match[1] === 'bestsellers' || match[1] === 'all') return;
  const star = '<svg width="11" height="11" viewBox="-50 -50 100 100" aria-hidden="true" focusable="false"><path fill="currentColor" d="M0-50 9-20 38-32 22-6 48 8 18 12 24 42 0 22-24 42-18 12-48 8-22-6-38-32-9-20z"/></svg>';
  let top = null;

  const tagCards = () => {
    if (!top) return;
    document.querySelectorAll('.card-wrapper').forEach((card) => {
      const inner = card.querySelector('.card__inner');
      if (!inner || inner.querySelector('.cm-badge--bestseller')) return;
      const link = card.querySelector('a[href*="/products/"]');
      if (!link) return;
      const handle = link.getAttribute('href').split('/products/')[1].split(/[?#/]/)[0];
      if (!top.includes(handle)) return;
      const tag = document.createElement('span');
      tag.className = 'cm-badge cm-badge--bestseller mba-bs-tag';
      tag.innerHTML = `${star}Bestseller`;
      inner.prepend(tag);
    });
  };

  fetch(`${path}?sort_by=best-selling&section_id=mba-bs-handles`)
    .then((r) => r.text())
    .then((html) => {
      const m = html.match(/data-bs-handles="([^"]*)"/);
      top = m && m[1] ? m[1].split(',') : [];
      tagCards();
      // Re-tag when the grid is re-rendered by filters/sorting/pagination
      const grid = document.getElementById('ProductGridContainer') || document.body;
      new MutationObserver(tagCards).observe(grid, { childList: true, subtree: true });
    })
    .catch(() => {});
})();
